export const REQUEST_CONSULTATIONS = "list-consultations";
export const SEARCH_REQUEST_CONSULTATIONS = "search-consultations";
export const CONSULTATIONS_LOADED = "loaded-consultations";
export const REQUEST_UNLOCK_CONSULTATION = "unlock-consultation";
export const CONSULTATION_UNLOCKED = "unlocked-consultation";

export const REQUEST_CONSULTATIONS_PRACTITIONER = "list-practitioner-consultations";
export const SEARCH_CONSULTATION_PRACTITIONER = "search-practitioner-consultation";

export const SEARCH_CONSULTATION_PATIENT = "search-patient-consultation";

export const REQUEST_DETAILS_CONSULTATION = "details-consultations";

export function requestConsultations() {
    return {
        type: REQUEST_CONSULTATIONS,
    };
}

export function searchConsultations(payload) {
    return {
        type: SEARCH_REQUEST_CONSULTATIONS,
        data: payload
    };
}

export function requestConsultationsPractitioner(payload) {
    return {
        type: REQUEST_CONSULTATIONS_PRACTITIONER,
        payload: payload
    };
}

export function searchConsultationsPractitioners(payload) {
    return {
        type: SEARCH_CONSULTATION_PRACTITIONER,
        data: payload
    };
}

export function searchConsultationsPatients(payload) {
    return {
        type: SEARCH_CONSULTATION_PATIENT,
        data: payload
    };
}

export function requestDetailsConsultation(payload) {
    return {
        type: REQUEST_DETAILS_CONSULTATION,
        payload: payload
    }
}

export function loadedConsultations(payload) {
    return {
        type: CONSULTATIONS_LOADED,
        payload: payload
    };
}

export function requestUnlockConsultation(payload) {
    return {
        type: REQUEST_UNLOCK_CONSULTATION,
        payload: payload
    }
}

export function unlockedConsultation(payload) {
    return {
        type: CONSULTATION_UNLOCKED,
        payload: payload
    };
}


// WEBPACK FOOTER //
// ./src/actions/consultations.action.js